module.exports = __webpack_public_path__ + "img/benefit-image09.5a5a47d6.png";